import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, IconButton, Toolbar, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { useData } from '../../hooks/UseData';
import { getLogger } from '../../utils/Logger';
import { AppLink } from '../ui/AppLink';
import HeaderButton from '../ui/HeaderButton';
import DrawerLeft from './DrawerLeft';

const logger = getLogger(import.meta.url);

export interface HeaderProps {
  logoSrc: string;
  buttonIconSrc: string;
  buttonIconSmallSrc: string;
  buttonIconBackgroundColor: string;
  linkPath: string;
}
const Header: React.FC<HeaderProps> = ({
  logoSrc,
  buttonIconSrc,
  buttonIconSmallSrc,
  buttonIconBackgroundColor,
  linkPath,
}) => {
  const { fetchHeaderData } = useData();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const showHeaderButtons = useMediaQuery('(min-width:670px)');
  const showFullLogo = useMediaQuery('(min-width:800px)');

  const handleDrawerToggle = () => {
    setDrawerVisible(!drawerVisible);
  };

  logger.debug(`START`);

  const headerData = fetchHeaderData();
  return (
    <>
      <AppBar
        key={linkPath} // サイト切り替え時に再利用されるのを防ぐ
        sx={{
          left: '0px',
        }}
      >
        <Toolbar
          sx={{
            // 狭い時はロゴを中央寄せ
            justifyContent: showHeaderButtons ? 'left' : 'center',
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            sx={{
              // 狭い時のみ表示。ボタンを縦センタリングするためinline-flexを使用
              display: showHeaderButtons ? 'none' : 'inline-flex',
              // 左寄せのためpositionとleftを指定
              position: 'absolute',
              left: 0,
            }}
          >
            <MenuIcon />
          </IconButton>
          <AppLink
            to={{ pathname: '/' }}
            style={{ textDecorationLine: 'none' }}
          >
            <Box
              display="flex"
              alignItems="flex-end"
              sx={{
                // 広い時は拡大し、ボタンとのパディングを指定
                height: showHeaderButtons ? '28px' : '24px',
                pr: showHeaderButtons ? 3 : 0,
              }}
            >
              <img src={logoSrc} width="auto" height="100%" alt="logo" />
            </Box>
          </AppLink>
          {Object.entries(headerData.buttons).map(([buttonId, items]) => (
            <HeaderButton
              key={buttonId}
              buttonId={buttonId}
              items={items}
              sx={{
                // inlineにしないとセンタリングされない
                display: showHeaderButtons ? 'inline' : 'none',
                verticalAlign: 'bottom',
              }}
            />
          ))}
          <IconButton
            color="inherit"
            sx={{
              // 右寄せのためpositionとrightを指定
              position: 'absolute',
              height: '100%',
              right: 0,
              p: 1.5,
            }}
            onClick={() => {
              window.location.href = linkPath;
            }}
          >
            <Box
              height="100%"
              display="flex"
              alignItems="center"
              px={showFullLogo ? 1 : 0.5} //ロゴの場合は横の余白を多めに確保
              py={0.5}
              borderRadius={1}
              sx={{
                aspectRatio: '1 / 1', // 画像ロード前に表示領域を確保
                backgroundColor: buttonIconBackgroundColor,
              }}
            >
              {showFullLogo ? (
                <img src={buttonIconSrc} height="60%" />
              ) : (
                <img src={buttonIconSmallSrc} height="100%" />
              )}
            </Box>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DrawerLeft
        buttonsData={headerData.buttons}
        linkPath={linkPath}
        visible={drawerVisible}
        setVisible={setDrawerVisible}
      />
    </>
  );
};

export default Header;
